import {Container} from 'react-bootstrap';
import {Row} from 'react-bootstrap';
import {Col} from 'react-bootstrap';

function Contact(){
    
    // const iconColor = {background:"tomato"};

   return(
   <div className="contact-content">
        <Container >

            <div className="Contact" id="contact">
                <h2 className="contact-head">Contact Me</h2>
                <hr className="contact-line"/>
            </div>

  <Row className="cs-row mt-5"> 
    <Col xs={12} md={6}>
            <a href="mailto:vidhurrk@gmail.com" className="btn m-5">Email Me</a>  
    </Col>
    <Col xs={12} md={6}>
            <a href="tel:+917975210262" className="btn m-5">Call Me</a> 
    </Col>
  </Row>

  <Row className="copyright mt-5"> 
    <small className="p-2">© Copyright Vidhur RK | 2021</small>
  </Row>

</Container>
  </div>
);
}

export default Contact;